import React from 'react';
import styled from 'styled-components';

import * as Common from '../../Styles';

export const Dialog = styled(Common.Dialog)``;

export const DialogActions = styled(Common.DialogActions)``;

export const DialogTitle = styled(Common.DialogTitle)``;

export const DialogContent = styled(Common.DialogContent)``;

export const ButtonGroup = styled(Common.ButtonGroup)``;

export const Button = styled(Common.Button)``;

export const OutlinedBlueButton = styled(Common.OutlinedBlueButton)``;

export const ButtonWithLoader = styled(Common.ButtonWithLoader)``;

export const CircularButton = styled(Common.CircularButton)``;

export const FlexRow = styled(Common.FlexRow)``;

export const TableContainer = styled(Common.TableContainer)``;

export const Table = styled(Common.Table)``;

export const TableHeader = styled(Common.TableHeader)``;

export const TableBody = styled(Common.TableBody)``;

export const TableRow = styled(Common.TableRow)``;

export const TableHeaderRow = styled(Common.TableHeaderRow)``;

export const TableColumn = styled(Common.TableColumn)``;

export const TableHeaderColumn = styled(Common.TableHeaderColumn)``;

export const TablePagination = styled(Common.TablePagination)``;

export const NotFound = styled(Common.NotFound)``;
